module.exports = __webpack_public_path__ + "media/Model_X_Navigte_0.b898ce75.mp4";